import React from "react";
import MyModal from "../../../../Common/my-modal/my-modal.component";
import styles from "./index.module.scss";

interface DeleteStatusModalProps {
  show: boolean;
  associatedMSPs: number;
  onHide: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const DeleteStatusModal: React.FC<DeleteStatusModalProps> = ({
  show,
  associatedMSPs,
  onHide,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <MyModal show={show} onHide={onHide}>
      <MyModal.Header className="border-bottom" closeButton onCrossClick={onHide}>
        <MyModal.HeaderTitle className="text-align-center w-100">
          Delete Status
        </MyModal.HeaderTitle>
      </MyModal.Header>
      <MyModal.Body className={styles.modalBody}>
        <div className="f-14 line-height-22 f-black">
          This status is associated with {associatedMSPs} clients. Are you sure you want to delete this status?
        </div>
      </MyModal.Body>
      <MyModal.Footer className="d-flex gap-4 border-top">
        <MyModal.CancelButton onClick={onHide} disabled={isLoading}>
          Cancel
        </MyModal.CancelButton>
        <MyModal.ApplyButton onClick={onConfirm} loading={isLoading} className={styles.applyButton} red>
          Delete Status
        </MyModal.ApplyButton>
      </MyModal.Footer>
    </MyModal>
  );
};

export default DeleteStatusModal;

